import React from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';

const useStyles = createUseStyles({
  iconButton: {
    width: 14,
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    padding: 0,
    margin: 0,
    '&:focus': {
      outline: 'none',
    },
  },
  icon: {
    width: '100%',
    transition: 'transform 0.5s'
  },
  openIcon: {
    transform: 'rotate(180deg)',
  }
});

const ToggleButton = ({ 
  onClick,
  open,
  className,
}) => {
  const classes = useStyles();

  if (!onClick) return null;

  return (
    <button 
      className={clsx(classes.iconButton, className)}
      onClick={onClick}
    >
      <img 
        alt="" 
        src={process.env.PUBLIC_URL + '/images/icons/arrow-down.svg'} 
        className={clsx(open && classes.openIcon, classes.icon)} 
      />
    </button>
  );
}

export default ToggleButton;